import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ChatHttpService } from '../../../../services/chat-http.service';
import { ChatService } from '../../../../services/chat.service';
import { Utils } from '../../../../classes';
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: 'nz-modal-create-chat',
  templateUrl: './create-chat.component.html',
  styleUrls: ['./create-chat.component.scss']
})
export class NzModalCreateChatComponent implements OnInit {
  @Input() cancelTextBtn: string = 'Отменить';
  @Input() confirmTextBtn: string = 'Отправить';

  userEmail = new FormControl('', Validators.required);
  userPhone = new FormControl('', Validators.required);

  serverError = '';
  unsubscribe$ = new Subject();
  ids = [1, 2, 3, 4, 5, 6];
  isSuccess = false;
  isInviteSend = false;
  isCreateChat = false;
  phone: any;
  email: any;
  isInviteStep = false;
  isSuccessInvite = false;
  isSuccessCreate = false;

  constructor(private modal: NzModalRef,
              private chatHttp: ChatHttpService,
              private chatService: ChatService) { }

  ngOnInit(): void {
    this.userEmail.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(()=> {
      this.serverError = '';
    })
    this.userPhone.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(()=> {
      this.serverError = '';
    })
  }
  destroyModal(): void {
    this.unsubscribe();
    this.modal.destroy();
  }

  confirmModal() {
    this.unsubscribe();
    this.modal.destroy({ data: true });
  }

  unsubscribe() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  inviteChat() {
    const data = {
      UserEmail: this.userEmail.value,
      UserPhone: Utils.clearPhone(this.userPhone.value),
    };
    /*data.UserEmail =  Utils.clearPhone(data.UserEmail);*/
    // this.email = data.UserEmail;

    this.chatHttp.inviteChat(data).subscribe(x => {
      this.isSuccess = true;
      this.isInviteSend = false;
      this.isSuccessInvite = true;
      this.chatService.chatUpdate();
    }, error => {
      this.serverError = error.error.detail;
    });
  }

  submit() {
    if (this.userPhone.invalid) {
      this.userPhone.markAllAsTouched();
      return;
    }

    const data = {
      UserPhone: this.userPhone.value
    } ;
    data.UserPhone =  Utils.clearPhone(data.UserPhone);
    this.phone = data.UserPhone;
    this.chatHttp.chatCreate(data).subscribe(x => {
      this.isSuccess = true;
      this.isCreateChat = true;
      this.chatService.chatUpdate();
    }, (error: HttpErrorResponse) => {
      if (error.status === 402) {
        this.isInviteStep = true;
        return;
      }
      this.serverError = error.error.detail;

    })

  }
}
